import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { adminFetch } from "../../lib/adminApi";

// Handles {redirect}#session_id=... from Emergent Google auth; exchanges it server-side for an httpOnly cookie.
const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { navigate("/admin/login", { replace: true }); return; }
    adminFetch("/api/auth/session", { method: "POST", body: { session_id: sessionId } })
      .then((user) => navigate("/admin/orders", { replace: true, state: { user } }))
      .catch((e) => navigate("/admin/login", { replace: true, state: { error: e.message } }));
  }, [location.hash, navigate]);

  return <div className="min-h-screen bg-[#0A0A0A] pt-32 text-center text-gray-500" data-testid="auth-callback">Signing in…</div>;
};

export default AuthCallback;
